module.exports = __webpack_public_path__ + "img/device_am35_d_b.5ba21917.png";